var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6022_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5 0H8.5C4.08172 0 0.5 3.58172 0.5 8V60C0.5 64.4183 4.08172 68 8.5 68H60.5C64.9183 68 68.5 64.4183 68.5 60V8C68.5 3.58172 64.9183 0 60.5 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9708 31.1627L10.1489 28.1761C9.78468 27.7907 9.78468 27.188 10.1489 26.8026L24.6777 11.4261C24.883 11.2089 25.1746 11.0949 25.4727 11.1153L33.4976 11.6632C33.7564 11.6809 33.9983 11.7985 34.1721 11.9911L45.6581 24.7261C45.8491 24.9378 45.9406 25.2208 45.9097 25.5042L45.3316 30.8066C45.2392 31.6543 44.1963 32.0048 43.6106 31.385L27.7382 14.5867C27.3436 14.1691 26.6791 14.1691 26.2845 14.5867L26.1502 14.7289L14.5119 31.0563C14.1463 31.5692 13.4033 31.6205 12.9708 31.1627Z",
    fill: "#12FFBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.029 35.7955L58.851 38.7821C59.2152 39.1675 59.2152 39.7702 58.851 40.1556L44.3221 55.5321C44.1168 55.7493 43.8252 55.8633 43.5271 55.8429L35.5022 55.295C35.2434 55.2773 35.0015 55.1598 34.8277 54.9671L23.3417 42.2321C23.1507 42.0205 23.0592 41.7374 23.0901 41.454L23.6682 36.1516C23.7606 35.3039 24.8035 34.9534 25.3892 35.5732L41.2616 52.3715C41.6562 52.7891 42.3207 52.7891 42.7153 52.3715L42.8496 52.2293L54.4879 35.9019C54.8535 35.389 55.5965 35.3377 56.029 35.7955Z",
    fill: "#12FFBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3383 12.4708L40.3248 9.64888C40.7103 9.28468 41.313 9.28468 41.6984 9.64888L57.0748 24.1777C57.292 24.383 57.4061 24.6746 57.3857 24.9727L56.8378 32.9976C56.8201 33.2564 56.7025 33.4983 56.5099 33.6721L43.7749 45.1581C43.5632 45.3491 43.2801 45.4406 42.9968 45.4097L37.6944 44.8316C36.8467 44.7392 36.4962 43.6963 37.116 43.1106L53.9142 27.2382C54.3319 26.8436 54.3319 26.1791 53.9142 25.7845L53.772 25.6502L37.4447 14.0119C36.9318 13.6463 36.8805 12.9033 37.3383 12.4708Z",
    fill: "#12FFBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7676 55.5101L28.9542 58.3013C28.5643 58.6881 27.9355 58.6881 27.5456 58.3013L12.948 43.8187C12.7427 43.615 12.6357 43.3325 12.6544 43.0439L13.1782 34.9903C13.1945 34.7387 13.3053 34.5024 13.4884 34.3291L25.5967 22.8622C25.8112 22.6591 26.1046 22.5612 26.3981 22.5948L31.3894 23.1662C32.2228 23.2616 32.5755 24.2788 31.98 24.8696L15.9446 40.7787C15.5503 41.1698 15.5503 41.8074 15.9446 42.1985L16.0971 42.3498L31.6625 53.9996C32.1513 54.3655 32.201 55.0801 31.7676 55.5101Z",
    fill: "#12FFBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7846 29.947L30.5524 33.2369C30.1653 33.6308 30.1709 34.264 30.5649 34.651L33.8548 37.8833C34.2487 38.2703 34.8818 38.2647 35.2689 37.8708L38.5012 34.5809C38.8882 34.187 38.8826 33.5538 38.4887 33.1668L35.1988 29.9345C34.8048 29.5475 34.1717 29.553 33.7846 29.947Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6022_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b0b90eb18ab752b04be5ce2b828c5597.svg";
export { ForwardRef as ReactComponent };